import { HTTPIntegration } from 'libs/end-to-end/src/types/databases/integrations/http-integration';

export const validateHTTPIntegrationShared = ({
  integration,
}: {
  integration: HTTPIntegration | null;
}): string[] => {
  const errorReasons: string[] = [];

  if (!integration) {
    errorReasons.push('Integration is required.');
    return errorReasons;
  }

  const {
    urlList,
    customHeaderList,
    customHeadersWithSecrets,
    timeoutInSeconds,
    retryCount,
  } = integration;

  for (const urlItem of urlList) {
    if (urlItem.url.trim() === '') {
      errorReasons.push('One or more of your URLs is empty.');
    }

    if (urlItem.filename.trim() === '') {
      errorReasons.push('One or more of your filenames is empty.');
    }
  }

  for (const customHeaderItem of customHeaderList) {
    if (customHeaderItem.key.trim() === '') {
      errorReasons.push('One or more of your custom header keys is empty.');
    }

    if (customHeaderItem.value.trim() === '') {
      errorReasons.push('One or more of your custom header values is empty.');
    }
  }

  if (
    customHeadersWithSecrets.headerName.trim() !== '' &&
    !customHeadersWithSecrets.headerSecretReference
  ) {
    errorReasons.push(
      'You must provide a secret reference for your custom header value.',
    );
  }

  if (
    customHeadersWithSecrets.headerSecretReference &&
    customHeadersWithSecrets.headerName.trim() === ''
  ) {
    errorReasons.push(
      'You must provide a header name for your custom header value.',
    );
  }

  if (timeoutInSeconds <= 0) {
    errorReasons.push('Timeout must be greater than 0.');
  }

  if (timeoutInSeconds > 86400) {
    errorReasons.push('Timeout must be less than 24 hours.');
  }

  if (retryCount <= 0) {
    errorReasons.push('Retry count must be greater than 0.');
  }

  if (retryCount > 5) {
    errorReasons.push('Retry count must be less than or equal to 5.');
  }

  return errorReasons;
};
